import ViewsRouter from '@/views/ViewsRouter.vue'
import ViewsOrderSubmitted from '@/views/order/ViewsOrderSubmitted.vue';
import ViewsOrderSubmit from '@/views/order/ViewsOrderSubmit.vue';

import {home} from '@/router/breadcrumbs';
import {PERMISSIONS} from '@/constants';
import {RouteRecordRaw} from 'vue-router';

export default [
    {
        path: '/order',
        name: 'order-parent',
        component: ViewsRouter,
        children: [
            {
                path: '',
                name: 'order.submit',
                component: ViewsOrderSubmit,
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [home, {text: 'order.submit'}],
                    permissions: [PERMISSIONS.EMPLOYEE]
                }
            },
            {
                path: 'submitted',
                name: 'order.submitted',
                component: ViewsOrderSubmitted,
                meta: {
                    requiresAuth: true,
                    permissions: [PERMISSIONS.EMPLOYEE]
                }
            }
        ]
    }
] as RouteRecordRaw[]